import Snowboard from './containers/Snowboard';
export default Snowboard